import React, { useState } from "react";
import BB from './Images/BB.png';
import { Menu, X } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDoorOpen, faTruck } from "@fortawesome/free-solid-svg-icons";
import { decryptData } from '../utils/storageCrypto';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const enMobile = sessionStorage.getItem('mobile');
  const mobile = decryptData(enMobile);
  return (
    <div className="relative bg-white border-b border-gray-200 shadow-sm">
      {/* Top Bar */}
      <div className="max-w-md mx-auto flex items-center justify-between px-4 py-3">
        {/* Left: BB Logo */}
        <div className="flex items-center gap-2">
          <img
            src={BB}   // place in public folder
            alt="BB"
            className="h-8 w-auto"
          />
        </div>

        {/* Right: Hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="p-2 rounded-lg hover:bg-gray-100"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Dropdown Menu */}
      {open && (
       <div className="absolute top-full left-0 w-full bg-white border-t border-gray-200 shadow-lg z-50">
  <div className="max-w-md mx-auto px-4 py-4 space-y-4">
       <p className="text-sm text-gray-500">
              Hello, Delivery Partner
            </p>


    {/* Rides */}
    <button
      onClick={() => {
        window.location.href = `/delivery/rides?mobile=${mobile}`;
      }}
      className="w-full flex items-center gap-3 py-2 text-gray-800 font-medium rounded-lg hover:bg-gray-50 transition"
    >
      <FontAwesomeIcon icon={faTruck} className="text-gray-500" />
      <span>Rides</span>
    </button>

    {/* Logout */}
    <button
      onClick={() => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/delivery";
      }}
      className="w-full flex items-center gap-3 py-2 text-red-600 font-semibold rounded-lg hover:bg-red-50 transition"
    >
      <FontAwesomeIcon icon={faDoorOpen} />
      <span>Logout</span>
    </button>
  </div>
</div>

      )}
    </div>
  );
};

export default Navbar;
